module.exports = __webpack_public_path__ + "img/f.c2b58b5f.jpg";